import {
  CHANGE_THEME,
  GET_THEME,
  TOGGLE_MENU,
  CHANGE_MENU_ACTIVE,
  GET_MAX_HEIGHT_EXPANDED,
  SET_MAX_HEIGHT_EXPANDED
} from "./../actions/types";

const initialState = {
  theme: localStorage.getItem("theme") || "dark",
  showMenu: false,
  menuActive: "",
  maxHeightExpanded: 0
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_THEME:
      return {
        ...state
      };
    case CHANGE_THEME:
      return {
        ...state,
        theme: action.payload
      };
    case TOGGLE_MENU:
      return {
        ...state,
        showMenu: !state.showMenu
      };
    case CHANGE_MENU_ACTIVE:
      return {
        ...state,
        menuActive: action.payload
      };
    case GET_MAX_HEIGHT_EXPANDED:
      return {
        ...state
      };
    case SET_MAX_HEIGHT_EXPANDED:
      return {
        ...state,
        maxHeightExpanded: action.payload
      };
    default:
      return state;
  }
}
